var highContrast = false;

console.log("Page type: ");

document.addEventListener('DOMContentLoaded', function() {
    highContrast = localStorage.getItem('highContrast') === 'true';
  const contrastButton = document.getElementById('contrastButton');
    if(highContrast){
      setHighContrastColors();
      contrastButton.innerText = "Standard Theme";
    }
    
    if (contrastButton) {
        contrastButton.addEventListener('click', function() {
            // Toggle highContrast setting
            localStorage.setItem('highContrast', !highContrast);
            highContrast = !highContrast;
            if(highContrast){
              setHighContrastColors();
              contrastButton.innerText = "Standard Theme";
            }
            else{
              location.reload();
            }
        });
    }
});

if(highContrast)
{
  setHighContrastColors;
}
function setHighContrastColors(){
  //HEADER
  document.getElementById("header-wrapper").style.background = "#e3dcd2";
  
  // Select all elements with the class 'cls-1'
  var elements = document.querySelectorAll('.cls-1');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#e3dcd2';
  });

  // Select all elements with the class 'cls-2'
  elements = document.querySelectorAll('.cls-2');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      console.log("in here");
      element.style.fill = '#f2400b';
  });

  // Select all elements with the class 'cls-3'
  elements = document.querySelectorAll('.cls-3');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });

  elements = document.querySelectorAll('.icon-cart-color');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });

  elements = document.querySelectorAll('.icon-back-color');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });

  elements = document.querySelectorAll('.account-icon-color');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.fill = '#000000';
  });

  

  //BADGES
  
  document.getElementById("header-divider").style.backgroundColor = "#000000";

  const agreementDisclaimer = document.getElementById("agreement-disclaimer");
  if (agreementDisclaimer) {
    // If it exists, change its color
    agreementDisclaimer.style.color = "#000000";
  }

  var element = document.getElementById("main-image-wrapper")
  if(element)
    element.style.background = "#e3dcd2";
  
  document.body.style.background = "#e3dcd2";

  document.getElementById("release-history").style.color = "#000000";
  document.getElementById("Layer_1").style.fill = "#000000";
  
  document.getElementById("release-number-badge").style.backgroundColor = "#000000";
  document.getElementById("release-number-badge").style.borderColor = "#000000";
  document.getElementById("release-number-badge").style.color = "#f2400b";

  document.getElementById("unit-count-badge").style.backgroundColor = "#f2400b";
  document.getElementById("unit-count-badge").style.borderColor = "#f2400b";
  document.getElementById("unit-count-badge").style.color = "#000000";

  document.getElementById("product-type-badge").style.backgroundColor = "#e3dcd2";
  document.getElementById("product-type-badge").style.borderColor = "#000000";
  document.getElementById("product-type-badge").style.color = "#000000";

  //TITLE
  document.getElementById("product-title").style.color = "#000000";

  //DESCRIPTION
  elements = document.querySelectorAll('.description');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#000000';
  });

  elements = document.querySelectorAll('.product__info-wrapper');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.borderColor = '#000000';
  });

  elements = document.querySelectorAll('.border-bottom');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.borderColor = '#000000';
  });
  
  elements = document.querySelectorAll('.product__info-wrapper p');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#000000';
  });

  //PRICE
  elements = document.querySelectorAll('.price-item');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#000000';
  });
  
  elements = document.querySelectorAll('.price-wrapper');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.borderColor = '#f2400b';
  });

  var element = document.getElementById("agreement")
  if(element)
    element.style.borderColor = "#f2400b";
  

  elements = document.querySelectorAll('.product-form__submit');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.backgroundColor = '#f2400b';
      element.style.borderColor = '#f2400b';
  });

  elements = document.querySelectorAll('.atc-text');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#000000';
  });

  elements = document.querySelectorAll('.atc-subtext');
  
  // Iterate over each element and change its fill color
  elements.forEach(element => {
      element.style.color = '#000000';
  });
  
}